import { mapperModuleCompanyFormulaItem } from '../../modules/mappers.js'

/**
 * Block careers formula mapper
 * normalizes data to be used in pages
 * @param {Object} data - cms data
 * @param {Function} getUrl - returns localized url
 * @return {Object} - normalized page data
 */
export const mapperBlockCompanyFormula = (data: any, transformShortDescription = false) => {
  if (!data) {
    return null
  }

  return {
    title: data.title || '',
    description: data.description || '',
    items:
      data.itemsCollection?.items?.map((item: any) =>
        mapperModuleCompanyFormulaItem(item, transformShortDescription)
      ) || []
  }
}
